/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum groupByEnum {
    DIAGNOSIS = 'diagnosis',
    DIAGNOSIS_GROUP = 'diagnosisGroup',
    DIAGNOSIS_DOMAIN = 'diagnosisDomain',
    USER_TYPE = 'userType',
    COUNTRY = 'country',
    PLAN_TYPE = 'planType',
    PLAN = 'plan',
    GRANT = 'grant',
}